export const SETTLEMENT_ADDRESS = '0xbf95c7e8ff9852a072238cd11c8be39fab76a40f';
export const PAID_FEATURE_RECEIVER = '0xe8d8528179f9166eb33bacd3cfa51ed1d477ab6e';
export const MINT_ID_RECEIVER = '0x4486a319c1d00432264fcb3e214d8bb7a785e396'; // 1. mint id  2. org verify

export const L2_CONTRACT_URL_MAP: Record<string, string> = {
  eth: '0x6f922284798de645e8bc1040450d32bde963c992',
  arb: '0x7bfc80a1dc182720220265e0fe0a02f0f4607748',
  bsc: '0x9c8e490bcc40873e6696de9af1669aa414d5eae1',
  op: '0x9e9d792ded4335a0e0002d0b1292a2e638a16772',
  matic: '0xf93517e466867c6ce1ccbd017681220ebfc8bd56',
};

export const L2_DEPOSIT_ADDRESS_MAP: Record<string, string> = {
  eth: '0x205e94337bc61657b4b698046c3c2c5c1d2fb8f1',
  bsc: '0x293391044c6981b6417fa0dcfd85524d4098a8d6',
  op: '0x824a2d0ae45c447caa8d0da4bb68a1a0056cadc6',
  arb: '0x40f480f247f3ad2ff4c1463e84f03be3a9a03e15',
  matic: '0xde74f4efdeec194c3f7b26be736bc8b5266ff7a5',
  base: '0x16ac3457ce84e6c5f80b394c59ccb2fd17049a62',
  avax: '0x16ac3457ce84e6c5f80b394c59ccb2fd17049a62',
};

export const L2_BRIDGE_TOKEN_MAP: Record<string, Record<string, string>> = {
  eth: {
    USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  },
  bsc: {
    USDC: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    USDT: '0x55d398326f99059ff775485246999027b3197955',
  },
  op: {
    USDC: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
    'USDC(Bridged)': '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
    USDT: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
  },
  arb: {
    USDC: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
    'USDC(Bridged)': '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    USDT: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
  },
  matic: {
    USDC: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
    'USDC(Bridged)': '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    USDT: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
  },
  avax: {
    USDC: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
    USDt: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
  },
  base: {
    USDC: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
  },
};

export const AVAILABLE_L2_CHAIN_IDS = ['eth', 'bsc', 'op', 'arb', 'matic', 'avax', 'base'];

export const getL2ContractAddress = (chainId: string = 'eth') => {
  return L2_CONTRACT_URL_MAP[chainId];
};
export const getL2DepositAddress = (chainId: string = 'eth') => {
  return L2_DEPOSIT_ADDRESS_MAP[chainId];
};

export const L2_ABI = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'oldWithdrawer',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newWithdrawer',
        type: 'address',
      },
    ],
    name: 'UpdWithdrawer',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'l2Accounts',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'nonces',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'l2Account',
        type: 'string',
      },
    ],
    name: 'register',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: 'token',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'send',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newWithdrawer',
        type: 'address',
      },
    ],
    name: 'transferWithdrawer',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'receiver',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: 'token_id',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'receiver',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'withdrawTargetToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

export const ABI = JSON.stringify(L2_ABI);

export enum AccountStatus {
  NORMAL = 'NORMAL',
  UNREGISTERED = 'UNREGISTERED',
  NO_KEY = 'NO_KEY',
  INVALID_KEY = 'INVALID_KEY',
}
